import { getJWTDecoded } from '../../helpers/helpers';

export default function AdultOnly({children}: any) {

    const isAdult: boolean = getJWTDecoded().isAdult;

    return isAdult 
        ? <>{children}</>
        : <></>
}